export default __webpack_public_path__ + "media/images/react_icons/reservation_wifi-a94be89a01321079727600a037abb41c.svg";